module.exports = __webpack_public_path__ + "assets/icon-next-light.44681b63.svg";